import { SubjectRawRule, ExtractSubjectType } from '@casl/ability';

import { Actions, Overrides, Subjects } from '../types';

type MergeRulesWithOverridesArgs = {
  rules: SubjectRawRule<Actions, ExtractSubjectType<Subjects>, unknown>[];
  overrides: Overrides;
  globalOverride?: boolean;
};
export const mergeRulesWithOverrides = ({
  rules,
  overrides,
  globalOverride,
}: MergeRulesWithOverridesArgs): MergeRulesWithOverridesArgs['rules'] => {
  return rules.map((rule) => {
    // Check for subject-specific override first
    const isEnabled =
      overrides[rule.subject as keyof typeof overrides]?.[
        rule.action as keyof (typeof overrides)[keyof typeof overrides]
      ];

    // Subject-specific overrides take precedence over global overrides
    const isEnabledFinal = isEnabled !== undefined ? isEnabled : globalOverride;

    if (isEnabledFinal !== undefined) {
      return {
        ...rule,
        reason: !isEnabledFinal ? rule.reason : undefined,
        inverted: !isEnabledFinal, // inverted means "cannot do", so invert the boolean
      };
    }

    return rule;
  });
};
